import { render } from "./UpdatePage.vue?vue&type=template&id=b5209ac4&scoped=true&ts=true"
import script from "./UpdatePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdatePage.vue?vue&type=script&setup=true&lang=ts"

import "./UpdatePage.vue?vue&type=style&index=0&id=b5209ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5209ac4"],['__file',"src/lib/components/UpdatePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5209ac4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5209ac4', __exports__)) {
    api.reload('b5209ac4', __exports__)
  }
  
  module.hot.accept("./UpdatePage.vue?vue&type=template&id=b5209ac4&scoped=true&ts=true", () => {
    api.rerender('b5209ac4', render)
  })

}


export default __exports__